import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { useApiQuery } from './useApiQuery';

const useGetUserAccessories = (hubRecord) => {
  const userEventsApi = useSelector((state) => state.apis.userEventsApi);
  const trans = useSelector(translator);
  const useruuid = hubRecord?.useruuid;

  return useApiQuery(
    ['getUserAccessories', useruuid],
    () =>
      new Promise((resolve, reject) => {
        try {
          userEventsApi.getUserAccessories(
            useruuid,
            { eventtypes: [] },
            apiCallback({
              translator: trans,
              successCallback: (data) => {
                const accessories = data?.['user_accessories'] || [];
                resolve(accessories);
              },
              errorCallback: () => reject(new Error('User accessories fetch failed')),
              failCallback: (err) => reject(err || new Error('User accessories fetch failed')),
            })
          );
        } catch (err) {
          reject(err);
        }
      }),
    {
      enabled: !!useruuid,
      staleTime: 0,
      gcTime: 0,
      refetchOnMount: 'always',
      refetchOnWindowFocus: 'always',
      refetchOnReconnect: 'always',
    }
  );
};

export default useGetUserAccessories;
